import { useContext } from "react";
import { LangContext } from "../../LangContext";
import IdeaCard from "../IdeaCard";
import Meta from "../common/Meta";
import Spinner from "../common/Spinner";

export default function IdeaTab({
  ideaIn, ideas, autoIdeas, ideaL, autoIdeaL, ideaErr,
  onIdeaInputChange, onGenIdeas, onMore,
}) {
  const lang = useContext(LangContext);
  return (
    <div>
      {/* Input */}
      <div className="p-4 border-b border-border-line">
        <div className="flex items-center gap-2.5 h-[44px] px-3.5 rounded-[10px]"
             style={{ background: "#262a30" }}>
          <span className="text-text-tertiary text-[15px] leading-none">⌕</span>
          <input
            value={ideaIn}
            onChange={e => onIdeaInputChange(e.target.value)}
            onKeyDown={e => e.key === "Enter" && onGenIdeas()}
            placeholder={lang === "en" ? "Reporting angle or hypothesis…" : "취재 각도 또는 가설…"}
            className="flex-1 min-w-0 bg-transparent border-none outline-none text-[15px] font-sans font-medium"
            style={{ color: "#888885" }}
          />
          {ideaIn && (
            <button onClick={() => onIdeaInputChange("")} aria-label="clear"
              className="w-[22px] h-[22px] rounded-full bg-[#3d4148] text-text-primary flex items-center justify-center text-[11px] border-none">✕</button>
          )}
        </div>
      </div>

      {ideaL && <Spinner message={lang === "en" ? "Cross-analyzing…" : "교차 분석 중…"} />}

      {ideaErr && (
        <div className="p-4 border-b border-border-line">
          <div className="text-[10px] text-tier-gun">{ideaErr}</div>
        </div>
      )}

      {/* User hypothesis results */}
      {(ideas || []).map((idea, i) => <IdeaCard key={`u${i}`} idea={idea} onMore={onMore} />)}

      {/* Auto ideas */}
      {autoIdeaL && <Spinner message={lang === "en" ? "Generating story ideas…" : "취재 아이디어 생성 중…"} />}
      {autoIdeas && (
        autoIdeas.map((idea, i) => <IdeaCard key={`a${i}`} idea={idea} onMore={onMore} />)
      )}
      {!autoIdeas && !autoIdeaL && (
        <div className="py-10 px-4 text-center">
          <Meta>{lang === "en" ? "Story ideas will be generated automatically when news loads" : "뉴스가 로드되면 취재 아이디어를 자동으로 생성합니다"}</Meta>
        </div>
      )}
    </div>
  );
}
